import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CircularProgress',
  props: {
    progress: {}
  },
  setup(__props: any) {

const props = __props;
const el = ref<HTMLDivElement | null>();
function createProgressCircle() {
  if (!el.value) {
    return;
  }

  el.value.innerHTML = "";

  const svgNS = "http://www.w3.org/2000/svg";
  const colors = [
    "#828282",
    "#29ADE2",
    "#FF9A1A",
    "#68B860",
    "#EB4B27",
    "#fde047",
  ];

  const svg = document.createElementNS(svgNS, "svg");

  svg.setAttribute("viewBox", "0 0 22 22");

  const centerX = 11;
  const centerY = 11;
  const radius = 9;
  let angle = -90;
  let progress = props.progress;
  for (let i = 0; i < progress.length; i++) {
    let p = progress[i];
    const color = colors[i];
    if (p == 1) p -= 0.0001;

    const startAngle = (angle * Math.PI) / 180;
    angle += p * 360;
    let endAngle = (angle * Math.PI) / 180;
    endAngle -= 0.01;

    const startX = centerX + radius * Math.cos(startAngle);
    const startY = centerY + radius * Math.sin(startAngle);

    const endX = centerX + radius * Math.cos(endAngle);
    const endY = centerY + radius * Math.sin(endAngle);

    const largeArcFlag = p > 0.5 ? 1 : 0;

    const path = document.createElementNS(svgNS, "path");
    path.setAttribute(
      "d",
      `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`
    );
    path.setAttribute("fill", "none"); // Set fill to none
    path.setAttribute("stroke", color); // Set stroke color
    path.setAttribute("stroke-width", "4"); // Set stroke width

    svg.appendChild(path);
  }
  if (el.value && el.value.appendChild) {
    el.value.appendChild(svg);
  }
}

onMounted(() => {
  setTimeout(() => {
    createProgressCircle();
  }, 1);
});

watch(
  () => props.progress,
  () => {
    createProgressCircle();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el,
    style: {"width":"22px","height":"22px"}
  }, null, 512))
}
}

})